bcn.dropDowns = (function () {
  'use strict';

  var buttonEl = '[data-toggle]';
  var dropdownEl = 'data-toggle-target';

  function toggleIcon (button, expanded) {
    var currentIcon = expanded ? 'icon-chevron-up' : 'icon-chevron-down';
    var newIcon = expanded ? 'icon-chevron-down' : 'icon-chevron-up';
    var svgIcon = button.find('svg').find('use').attr('xlink:href');

    button.find('svg').find('use').attr('xlink:href', svgIcon.replace(currentIcon, newIcon));
  }

  function toggleDropDown(button) {
    var expanded = JSON.parse(button.attr('aria-expanded'));
    var target = $('[' + dropdownEl + '="' + button.data('toggle') + '"]');
    button.toggleClass('active').attr('aria-expanded', !expanded);
    target.toggleClass('active');
    toggleIcon(button, expanded);
  }

  function clickButton () {
    $(buttonEl).on('click', function () {
      toggleDropDown($(this));
    });
  }

  function closeOnEscape () {
    $(document).on('keyup',function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        toggleIcon($(buttonEl + '.active'), true);
        $(buttonEl + '.active').removeClass('active').attr('aria-expanded', false);
        $('[' + dropdownEl + '].active').removeClass('active');
      }
    });
  }

  function clickLinks () {
    var parentEl;
    $('[' + dropdownEl +'] a').on('click', function () {
      parentEl = $(this).parents('[' + dropdownEl +']');
      if (parentEl.attr('data-ajax') !== 'true') {
        return;
      }
      var button = parentEl.prev($(buttonEl));
      toggleDropDown(button);
    });
  }

  return {
    init: function () {
      clickButton();
      closeOnEscape();
      clickLinks();
    },
    isReady: function () {

    }
  };

})();
